import { Group, Text, ThemeIcon, UnstyledButton, useMantineTheme } from "@mantine/core";
import { useLiveQuery } from "dexie-react-hooks";
import { Chat, db } from "../db";

interface MainLinkProps {
  icon: React.ReactNode;
  color?: string;
  label: string;
  chat: Chat;
}

export function MainLink({ icon, color, label, chat }: MainLinkProps) {
  const theme = useMantineTheme();
  const firstMessage = useLiveQuery(async () => {
    return (await db.messages.orderBy("createdAt").toArray()).filter(
      (m) => m.chatId === chat.id
    )[0];
  }, [chat]);

  return (
    <UnstyledButton
      sx={(theme) => ({
        width: "100%",
        padding: theme.spacing.xs,
        borderRadius: theme.radius.sm,
        color:
          theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
        '&:hover': {
          backgroundColor: theme.colorScheme === "dark" 
            ? theme.colors.dark[6] 
            : theme.fn.lighten(theme.colors[theme.primaryColor][6], 0.9),
        }
      })}
    >
      <Group>
        <ThemeIcon color={color || theme.primaryColor} variant="light">
          {icon}
        </ThemeIcon>
        <Text
          size="sm"
          style={{
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            overflow: "hidden",
            flex: 1,
            width: 0,
          }}
          sx={(theme) => ({
            color: firstMessage ? 
              (theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors[theme.primaryColor][7]) 
              : undefined,
            // Use theme colors for better consistency
            "&:hover": {
              color: theme.colors[theme.primaryColor][7]
            }
          })}
        >
          {label} <br />
          {firstMessage?.content}
        </Text>
      </Group>
    </UnstyledButton>
  );
}
